module.exports = __webpack_public_path__ + "img/icon-briefcase.128c23d7.svg";